import { NgModule } from '@angular/core';
import { MenuComponent } from './menu.component';
import { CommonModule } from '@angular/common';
import { PipesModule } from '../../pipes/pipes.module';
import { IbexIconModule } from '@ibexfusion/ibex-icon';
import { GlobalComponentsModule } from '../../components/global-components.module';
import { MenuPageRoutingModule } from './menu-routing.module';
import { CarouselModule } from "../../components/carousel/carousel.module";
import { LaunchersModule } from '../../components/launchers/launchers.module';

@NgModule({
  declarations: [
    MenuComponent
  ],
  imports: [CommonModule, PipesModule, IbexIconModule, GlobalComponentsModule, MenuPageRoutingModule, CarouselModule, LaunchersModule]
})
export class MenuModule {

}
